import HTTP from "../http";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async getCouponByName(text_search) {
    try {
      let results = await HTTP.normal.get(
        `/coupons?filter[name]=${text_search.toUpperCase()}&include=districts.rating,districts.pricing`
      );
      results = dataFormatter.deserialize(results.data);

      if (!results.length) throw "O cupom informado não existe!";

      return results[0];
    } catch (e) {
      throw e;
    }
  },

  async checkRestrictions(payload) {
    try {
      let params = Object.entries(payload.order)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      let result = await HTTP.normal.get(
        `coupons/${payload.coupon_id}/check-coupon-restrictions?${params}`
      );
    } catch (e) {
      throw "O cupom não pode ser aplicado ao pedido!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/coupons.js